import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

type ThisApi = ApiDefinition['/case-documents']['POST'];
type Input = ThisApi['body'];

const createFromDocx = async ({ name, content, creatorId }: Input): Promise<ThisApi['response']> => {
  const data = await formsBackendClient.post('/case-documents', { content, creatorId, name });
  return data.data;
};

export default createFromDocx;
